/* eslint-disable @typescript-eslint/no-explicit-any */
import { useFormikContext } from 'formik';
import RouteLeavingGuard from '../../RouteLeavingGuard';

const UnsavedFormPrompt = ({ path }: any) => {
    const formik = useFormikContext();
    // Commented out as this stopped working corrected and we couldn't find the culprit?
    // Left here in case we have time to investigate
    // window.onbeforeunload = () => (
    //   (formik.dirty === true && formik.isValid === false)
    //   || (formik.dirty === true && formik.submitCount === 0) ? true : undefined
    // );

    if (path === '/create-account/' || path === '/create-contact/') {
        return (
            <RouteLeavingGuard
                when={(formik.dirty === false && formik.isValid && formik.submitCount === 0)
                    || (formik.isValid === false && formik.submitCount === 0)
                    || (formik.isValid === false && Object.keys(formik.errors).length > 0)
                    || (formik.isValid === true && formik.submitCount === 0)
                    || (formik.isValid === true && formik.isSubmitting === false)}
                title='Are you sure you want to log out?'
                body='Any changes made will not be saved if you log out. You can log out, or cancel to stay on the page.'
                confirmBtn='Yes, logout'
            />
        );
    }
    return (
        <RouteLeavingGuard
            when={(formik.dirty === true && formik.isValid === false) || (formik.dirty === true && formik.submitCount === 0) || (formik.dirty === false && formik.isValid === false && formik.submitCount !== 0)}
        />
    );
};

export default UnsavedFormPrompt;
